export default __webpack_public_path__ + "static/media/yd.3ce074fc.jpeg";